import React from "react";
import Barcode128Svg from "../shared/Barcode128";

export interface IOpeningStickerSheetFooterProps {
  sheetNumber: number;
  totalSheets: number;
  contentHeight: number;
  margin: number;
  primaryColor?: string;
  secondaryColor?: string;
  primaryText?: string;
  secondaryText?: string;
  identifierText?: string;
  barcodeData?: string;
}

export default function OpeningStickerSheetFooter({
  sheetNumber,
  totalSheets,
  contentHeight,
  margin,
  primaryColor = "#000000",
  secondaryColor = "#BBBBBB",
  primaryText = "Photo Map Stickers",
  secondaryText = "",
  identifierText = "",
  barcodeData,
}: IOpeningStickerSheetFooterProps) {
  return (
    <div
      style={{
        position: "absolute",
        display: "flex",
        alignItems: "center",
        bottom: `${margin}px`,
        left: `${margin}px`,
        right: `${margin}px`,
        height: `${contentHeight}px`,
        color: primaryColor,
      }}
    >
      <div
        style={{
          flexGrow: 1,
          marginRight: "0.5em",
          lineHeight: "1em",
          alignSelf: "end",
        }}
      >
        <div
          style={{
            fontSize: "1em",
            fontWeight: "bold",
          }}
        >
          {primaryText}
        </div>
        <div
          style={{
            color: secondaryColor,
            fontSize: ".8em",
            marginTop: "-2px",
          }}
        >
          {secondaryText}
        </div>
      </div>
      {barcodeData && (
        <Barcode128Svg
          value={barcodeData}
          height={contentHeight}
          width={1.5}
          style={{
            marginRight: "0.5em",
            flexShrink: 0,
          }}
        />
      )}
      <div style={{ flexGrow: 0, fontSize: "0.8em", flexShrink: 0 }}>
        <Fraction numerator={sheetNumber + 1} denominator={totalSheets} />
      </div>
      <div style={{ fontSize: "16pt", lineHeight: 0 }}>{identifierText}</div>
    </div>
  );
}

type FractionProps = {
  numerator: number;
  denominator: number;
};

function Fraction({ numerator, denominator }: FractionProps) {
  if (denominator === 1) {
    return null;
  }
  return (
    <div
      style={{
        marginRight: "0.5em",
        color: "#666666",
        textAlign: "center",
        fontSize: "1.2em",
      }}
    >
      {numerator} of {denominator}
    </div>
  );
}
